goog.provide('el8.uiwidget.NewPasswordFields');


/**
 * This widget does client-side validation of new password fields:
 * - The first field enforces password security requirements: at least
 *     12 characters (default), including at least one number or symbol.
 * - The second field make sure the user entered the same password twice.
 */
el8.uiwidget.NewPasswordFields = function(spec) {

    spec = spec || {};

    // default of 12 can be overridden
    this._minLength = spec.minLength || 12;
    this._field1 = spec.field1;
    this._field2 = spec.field2;

    this._infoDiv1 = spec.infoDiv1;
    if (!this._infoDiv1) { this._selectorFn1 = spec.selectorFn1; }

    this._infoDiv2 = spec.infoDiv2;
    if (!this._infoDiv2) { this._selectorFn2 = spec.selectorFn2; }

    this._timeoutId1 = null;
    this._timeoutId2 = null;

    this._errorClass = spec.errorClass || null;

    this._DELAY = 1*1000; // 1 sec
};

el8.uiwidget.NewPasswordFields.prototype.init = function() {

    var that = this;
    this._field1.on('keyup', function(e) { that.validateField1(true); })
        .on('blur', function(e) { that.validateField1(); });
    if (this._field2) {
        this._field2.on('keyup', function(e) { that.validateField2(true); })
            .on('blur', function(e) { that.validateField2(); });
    }

    return this;
};

el8.uiwidget.NewPasswordFields.prototype.validateField1 = function(delayError) {
    if (this._timeoutId1) { clearTimeout(this._timeoutId1); }

    var that = this;
    var val = that._field1.val();
    if (val.length > 0) {
        if (val.length < that._minLength) {
            var tooShortFn = function() {
                that._getInfoDiv1().text(
                    "Password too short. Must be at least " + that._minLength + " characters."
                );
                if (that._errorClass) { that._getInfoDiv1().addClass(that._errorClass); }
            };
            // Only delay error if user didn't previously see an alert msg
            if (delayError && !that._getInfoDiv1().text()) {
                this._timeoutId1 = setTimeout(function() { tooShortFn(); }, this._DELAY);
            } else {
                tooShortFn();
            }
        } else if (!/(?=.*[\d!@#$%\^&*\-])/.test(val)) {
            var noSymbolFn = function() {
                that._getInfoDiv1().text(
                    "Password must contain at least one number or special character."
                );
                if (that._errorClass) { that._getInfoDiv1().addClass(that._errorClass); }
            };
            // Only delay error if user didn't previously see an alert msg
            if (delayError && !that._getInfoDiv1().text()) {
                this._timeoutId1 = setTimeout(function() { noSymbolFn(); }, this._DELAY);
            } else {
                noSymbolFn();
            }
        } else {
            that._getInfoDiv1().empty();
            if (that._errorClass) { that._getInfoDiv1().removeClass(that._errorClass); }
        }
    } else {
        that._getInfoDiv1().empty();
        if (that._errorClass) { that._getInfoDiv1().removeClass(that._errorClass); }
    }
};

el8.uiwidget.NewPasswordFields.prototype.validateField2 = function(delayError) {

    if (this._timeoutId2) { clearTimeout(this._timeoutId2); }

    var that = this;
    var val1 = that._field1.val();
    var val2 = that._field2.val();

    if (val1.length > 0) {
        if (val1 !== val2) {
            var noMatchFn = function() {
                that._getInfoDiv2().text(
                    "Passwords do not match."
                );
                if (that._errorClass) { that._getInfoDiv2().addClass(that._errorClass); }
            };
            if (delayError && !that._getInfoDiv2().text()) {
                this._timeoutId2 = setTimeout(function() { noMatchFn(); }, this._DELAY);
            } else {
                noMatchFn();
            }
        } else {
            that._getInfoDiv2().empty();
            if (that._errorClass) { that._getInfoDiv2().removeClass(that._errorClass); }
        }
    } else {
         that._getInfoDiv2().empty();
        if (that._errorClass) { that._getInfoDiv2().removeClass(that._errorClass); }
    }
};

el8.uiwidget.NewPasswordFields.prototype._getInfoDiv1 = function() {
    return this._infoDiv1 ? this._infoDiv1 : this._selectorFn1(this._field1);
};

el8.uiwidget.NewPasswordFields.prototype._getInfoDiv2 = function() {
    return this._infoDiv2 ? this._infoDiv2 : this._selectorFn2(this._field2);
};

/** API available in special cases **/
el8.uiwidget.NewPasswordFields.prototype.showError1 = function() {

    var that = this;
    this._getInfoDiv1().text(
        "Password too short. Must be at least " + that._minLength + " characters."
    );
    if (this._errorClass) { this._getInfoDiv1().addClass(this._errorClass); }
};
el8.uiwidget.NewPasswordFields.prototype.showError2 = function() {

    this._getInfoDiv2().text(
        "Passwords do not match."
    );
    if (this._errorClass) { this._getInfoDiv2().addClass(this._errorClass); }
};
